import { combineReducers } from 'redux'
import { Reducer } from 'interfaces'
import { RecaptchaState } from 'interfaces/recaptcha'
import { LOAD_RECAPTCHA_API, REGISTER_RECAPTCHA_WIDGET, UNREGISTER_RECAPTCHA_WIDGET } from 'actions/recaptchaActions'
import { isFailAction, isSuccessAction } from 'helpers/actionsHelpers'
import * as omit from 'lodash/omit'

const recaptchaStatusReducer: Reducer<RecaptchaState['status']> = (state = null, action) => {
  switch (action.type) {
    case LOAD_RECAPTCHA_API:
      if (isSuccessAction(action)) {
        return 'loaded'
      }
      if (isFailAction(action)) {
        return 'failed'
      }

    default:
      return state
  }
}

const recaptchaWidgetsReducer: Reducer<RecaptchaState['widgets']> = (state = {}, action) => {
  if (action.type === REGISTER_RECAPTCHA_WIDGET) {
    const { placement, widgetID, callback } = action.payload

    return {
      ...state,
      [placement]: {
        widgetID,
        callback,
      },
    }
  }

  if (action.type === UNREGISTER_RECAPTCHA_WIDGET) {
    return omit(state, action.payload.placement)
  }

  return state
}


export default combineReducers<RecaptchaState>({
  status: recaptchaStatusReducer,
  widgets: recaptchaWidgetsReducer,
})
